import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const initialState = () => ({
	data: null,
	type: null,
	candProgressResp: {},
	candProgressRespPrimary: {},
	candidateInfo: {},
	primaryCandidateInfo: {},
	allValidation: {},
	selectedAssessment: {},
	togglecreateNewProfile: false,
	previewResume: false,
	closeSurveyQues: false,
	openedgovtlink: [],
	interview: null,
	feedbackData: {},
	isCancelPanelNotfn: false,
	resclinicRename: false,
	selectedSkillsForInterview: [],
	selectedCompany: {},
	savedInterviewSkillState: null,
	isOnboardingActive: false,
	pendingOnboarding: null, // { step: 'skills'|'goals'|null } — set by router before SignupModal mounts
});

const state = initialState();

const getters = {
	getgovtids: (state) => state.openedgovtlink,
	getcandidateInfo: (state) => state.candidateInfo,
	getPrimaryCandidateInfo: (state) => state.primaryCandidateInfo,
	getCandProgressResp: (state) => state.candProgressResp,
	getCandProgressRespPrimary: (state) => state.candProgressRespPrimary,
	getToggleNotification: (state) => state.togglecreateNewProfile,
	getPreviewResume: (state) => state.previewResume,
	getselectedAssessment: (state) => state.selectedAssessment,
	getSurveyWidgetClose: (state) => state.closeSurveyQues,
	getInterview: (state) => state.interview,
	getFeedbackData: (state) => state.feedbackData,
	getIsCancelPanelNotfn: (state) => state.isCancelPanelNotfn,
	getSelectedSkillsForInterview: (state) => state.selectedSkillsForInterview,
	getSelectedCompany: (state) => state.selectedCompany,
	getSavedInterviewSkillState: (state) => state.savedInterviewSkillState,
	getIsOnboardingActive: (state) => state.isOnboardingActive,
	getPendingOnboarding: (state) => state.pendingOnboarding,
};

const mutations = {
	RESET_STATE(state) {
		Object.assign(state, initialState());
	},
	setResclinicRename(state, value) {
		state.resclinicRename = value;
	},
	storegovtids(state, data) {
		console.log(data);

		state.openedgovtlink.push(data);
		console.log(state.openedgovtlink, "vuex data");
	},
	removegovtid(state, data) {
		state.openedgovtlink = state.openedgovtlink.filter((id) => {
			id == data;
		});
	},
	setFeedbackData(state, data) {
		state.feedbackData = { ...data };
	},
	setData(state, data) {
		state.data = data;
	},
	setCandidateInfo(state, data) {
		state.candidateInfo = data;
	},
	setPrimaryProfile(state, data) {
		state.primaryCandidateInfo = data;
	},
	setType(state, data) {
		state.type = data;
	},
	popSkill(state, priorityID) {
		for (let i = 0; i < state.data.length; i++) {
			if (state.data[i].priorityID === priorityID) {
				state.data.splice(i, 1);
			}
		}
	},
	updateCandidateProgress(state, value) {
		state.candProgressResp = value;
	},
	updateCandidateProgressPrimary(state, value) {
		state.candProgressRespPrimary = value;
	},
	updatetogglecreateNewProfile(state, value) {
		state.togglecreateNewProfile = value;
	},

	updateAllValidation(state, value) {
		state.allValidation = value;
	},
	updatePreviewResume(state, value) {
		state.previewResume = value;
	},
	addSelectAssess(state, data) {
		state.selectedAssessment = data;
	},
	closeSurveyWidget(state, data) {
		state.closeSurveyQues = data;
	},
	setInterview(state, data) {
		console.log(data);
		state.interview = data;
	},
	setIsCancelPanelNotfn(state, data) {
		state.isCancelPanelNotfn = data;
	},
	setSelectedSkillsForInterview(state, data) {
		state.selectedSkillsForInterview = data;
	},
	setSelectedCompany(state, data) {
		state.selectedCompany = data;
	},
	setSavedInterviewSkillState(state, data) {
		state.savedInterviewSkillState = data;
	},
	setOnboardingActive(state, value) {
		state.isOnboardingActive = value;
	},
	setPendingOnboarding(state, payload) {
		// payload: { step: 'skills'|'goals'|null } or null to clear
		state.pendingOnboarding = payload;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
};
